"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appointmentMissed = exports.routing = exports.success = exports.provider = exports.pending = exports.initializing = exports.error = exports.confirmationPage = exports.cancelPage = exports.cancelingAppointment = exports.cancelFinished = exports.cancelExpiredPage = exports.cancelError = exports.canceledPreviously = exports.cancelDisabledPage = exports.cancelDisabled = exports.appointmentCancel = exports.appointment = void 0;
exports.appointment = '@state/APPOINTMENT';
exports.appointmentCancel = '@state/APPOINTMENT_CANCEL';
exports.cancelDisabled = '@state/CANCEL_DISABLED';
exports.cancelDisabledPage = '@state/CANCEL_DISABLED_PAGE';
exports.canceledPreviously = '@state/CANCELED_PREVIOUSLY';
exports.cancelError = '@state/CANCEL_ERROR';
exports.cancelExpiredPage = '@state/CANCEL_EXPIRED_PAGE';
exports.cancelFinished = '@state/CANCEL_FINISHED';
exports.cancelingAppointment = '@state/CANCELING_APPOINTMENT';
exports.cancelPage = '@state/CANCEL_PAGE';
exports.confirmationPage = '@state/CONFIRMATION_PAGE';
exports.error = '@state/ERROR';
exports.initializing = '@state/INITIALIZING';
exports.pending = '@state/PENDING';
exports.provider = '@state/PROVIDER';
exports.success = '@state/SUCCESS';
exports.routing = '@state/ROUTING';
exports.appointmentMissed = '@state/APPOINTMENT_MISSED';
//# sourceMappingURL=States.js.map